export const MAX_CLIENT_CHANNEL_IMAGE_SIZE_BYTES = 1 * 1024 * 1024
export const MAX_CLIENT_CHANNEL_IMAGE_SIZE_MB = 1

const CLIENT_CHANNEL_IMAGE_MIME_TYPES = [
  "image/jpeg",
  "image/png",
  "image/jpg",
  "image/pjpeg",
  "image/x-png",
] as const

export const CLIENT_CHANNEL_IMAGE_ACCEPT = "image/png,image/jpeg,image/jpg"

const clientChannelImageMimeTypeSet = new Set<string>(
  CLIENT_CHANNEL_IMAGE_MIME_TYPES
)

export const isValidClientChannelImageType = (file: File) =>
  clientChannelImageMimeTypeSet.has(file.type)

export const isClientChannelImageTooLarge = (file: File) =>
  file.size > MAX_CLIENT_CHANNEL_IMAGE_SIZE_BYTES
